let feeProducts = {
  running: false,

  init: function () {
    if (!this.running) {
      this.running = true;
      fetch('/cart.js').then(res => res.json()).then(response => {
        this.checkCartForFeeProduct(response);
      });
    }

  },

  checkCartForFeeProduct: function (data) {
    if (data.item_count < 1 || typeof data.items == "undefined") {
      this.running = false;
      return;
    }

    let items = data.items;
    let _this = this;

    let personalizedItemsKeys = [];
    let feeProductsQuantities = {};

    // get required quantities for each fee product
    items.forEach(function (item) {
      for (let i = 1; i < 4; i++) {
        if (typeof item.properties['_personalized_' + i] != "undefined" && item.properties['_personalized_' + i] == 'true') {

          if (typeof item.properties['_fee_product_' + i] != "undefined") {
            let id = item.properties['_fee_product_' + i];
            if (feeProductsQuantities.hasOwnProperty(id)) {
              feeProductsQuantities[id]++;
            } else {
              feeProductsQuantities[id] = 1
            }
          }
        }
      }
    });

    items.forEach(function (item) {
      let feeRequired = false;
      let feeInCart = false;
      let feeProductId = null;
      let feeItemKey = null;
      let targetItemKey = null;

      for (let i = 1; i < 4; i++) {
        // check if fee product needs to be added to cart and add it, if it's not already there
        if (typeof item.properties['_personalized_' + i] != "undefined" && item.properties['_personalized_' + i] == 'true') {
          feeRequired = true;
          personalizedItemsKeys.push(item.key)

          if (typeof item.properties['_fee_product_' + i] != "undefined") {
            feeInCart = false;
            feeProductId = null;
            feeItemKey = null;
            targetItemKey = null;

            let id = item.properties['_fee_product_' + i];
            feeProductId = parseInt(id);
            targetItemKey = item.key;

            items.forEach(function (feeItem) {
              if (feeItem.variant_id == feeProductId) {
                feeInCart = true;
                feeItemKey = feeItem.key;

                // fix qty if not enough/too many products in cart
                if (feeItem.quantity != feeProductsQuantities[feeProductId]) {
                  _this.updateItemQty(feeItemKey, feeProductsQuantities[feeProductId]);
                }
              }
            });

            // add fee product if required
            if (!feeInCart && feeRequired && feeProductId) {
              _this.addFeeProductToCart(feeProductId, targetItemKey);
            }

            // remove fee product if not required
            if (feeInCart && !feeRequired && feeProductId) {
              _this.updateItemQty(feeItemKey, 0);
            }
          }
        }
      }

    });

    this.removeWrongFeeProducts(items, personalizedItemsKeys, feeProductsQuantities);
  },

  addFeeProductToCart: function (id, targetItemKey) {
    let _this = this;
    let data = {
      quantity: 1,
      id: id,
      properties: {
        '_is_fee_product': true,
        '_target_item_key': targetItemKey
      }
    };
    fetch('/cart/add.js', {
      'method': 'POST',
      'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(response => {
      if ($('body').hasClass('template-cart') || $('body').hasClass('shopify-checkout')) location.reload();
      _this.running = false;
    });
  },

  updateItemQty: function (id, qty = 1) {
    let _this = this;
    fetch('/cart/change.js', {
      'method': 'POST',
      'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({id: id, quantity: qty})
    }).then(response => {
      if ($('body').hasClass('template-cart') || $('body').hasClass('shopify-checkout')) {
        location.reload();
      }
      _this.running = false;
    });
  },

  removeWrongFeeProducts: function (items, keys, feeProductsQuantities) {
    let _this = this;
    let updatedItems = 0;

    items.forEach(function (item) {
      if (typeof item.properties['_is_fee_product'] != "undefined") {
        if (!keys.includes(item.properties['_target_item_key'])) {
          for (let i = 1; i < 4; i++) {
            let id = parseInt(item.properties['_fee_product_' + i]);
            let qty = feeProductsQuantities[id];
            if (typeof qty == "undefined") qty = 0;
            _this.updateItemQty(item.key, qty);
            updatedItems++;
          }
        }
      }
    });

    if (updatedItems < 1) {
      this.running = false;
    }
  }

}

feeProducts.init();

document.addEventListener("cart:updated", (e) => {
  console.log('cart updated')
  feeProducts.init();
});